module.exports = __webpack_public_path__ + "static/bluewelcomebanner-12ce1347011635ab7bd6b4489c3c4493.jpeg";